<template>
  <main>
    <Header />
    <SectionMain />
    <SectionMap />
    <SectionBooking />
    <SectionApartments />
    <SectionWidget />
    <SectionContacts />
  </main>
</template>

<script>
import Header from './components/Header.vue'
import SectionMain from './components/SectionMain.vue'
import SectionMap from './components/SectionMap.vue'
import SectionBooking from './components/SectionBooking.vue'
import SectionContacts from './components/SectionContacts.vue'
import SectionApartments from './components/SectionApartments.vue'
import SectionWidget from './components/SectionWidget.vue'

export default {
  name: 'App',
  components: {
    Header,
    SectionMain,
    SectionMap,
    SectionBooking,
    SectionContacts,
    SectionApartments,
    SectionWidget,
  },
}
</script>

<style lang="scss" scoped></style>
